import React, { useState } from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import { MdDelete } from "react-icons/md";
import { Link } from 'react-router-dom';
import { FaGear } from 'react-icons/fa6';
import AsignarUsuario from './AsignarUsuario';

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'20%'}}>Posición</th>
        <th className='d-none d-sm-table-cell' style={{width:'50%'}}>Descripción posición</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Quitar</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Juez</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  
  if (props.listOfPosiciones) {
    
    const rows = props.listOfPosiciones.map((row, index) => { 

      return (      
        <tr key={index}>        
          <td>  
            {row["posicion"].nombreposicion}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row["posicion"].descripcionposicion}
          </td>  
          <td>
            <Button variant="secondary"><MdDelete /></Button>  
          </td> 
          {/*
          <td>
            <Button variant="secondary">
              <Link to = {`/editorganigramaareas/${row.id}`}><FaGear size={15} color='white'/></Link>      
            </Button>          
          </td> 
          */}
          <td>
            {/*{row.user?row.user.primerapellido + ", " + row.user.primernombre:null}  */}
            <AsignarUsuario 
              id={row.id} 
              organigramaareasid={row.id} 
              area={row.posicion}
              user={row.user}
              posicion={true}
            />              
          </td>           
                                     
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}
const CompetenciaPosicionesList = (props) => {        
  //console.log(props);
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode}/>
            <TableBody 
              mode={props.mode} 
              onSelected={props.onSelected} 
              listOfPosiciones={props.listOfPosiciones} 
            />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default CompetenciaPosicionesList;